import { render, staticRenderFns } from "./add1.vue?vue&type=template&id=685e350c&scoped=true&"
import script from "./add1.vue?vue&type=script&lang=js&"
export * from "./add1.vue?vue&type=script&lang=js&"
import style0 from "./add1.vue?vue&type=style&index=0&id=685e350c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e350c",
  null
  
)

export default component.exports